// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"35db0e9d","349":"3887adc5","407":"bb14f4dd","453":"5fa91324","732":"65551455"}[chunkId] + ".chunk.js");